module.exports = __webpack_public_path__ + "static/media/img_uniongroup_web.8558b165.png";